"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BROADCAST_UPDATE_REQUEST = exports.BROADCAST_APPROVE_ALL_KNOCKS = void 0;
var BROADCAST_UPDATE_REQUEST = exports.BROADCAST_UPDATE_REQUEST = 'BROADCAST_UPDATE_REQUEST';
var BROADCAST_APPROVE_ALL_KNOCKS = exports.BROADCAST_APPROVE_ALL_KNOCKS = 'BROADCAST_APPROVE_ALL_KNOCKS';